<template>
  <span>{{ formatted }}</span>
</template>

<script>
// Datetimeago component
// renders a human-readable countdown to a date (e.g. 'in 3 days')
// auto-updates every second

import dates from '../../services/dates'

export default {
  props: ['value'],
  data: function () {
    return {
      now: Date.now()
    }
  },
  mounted: function () {
    this.interval = setInterval(() => {
      this.now = Date.now()
    }, 1000)
  },
  destroyed: function () {
    clearInterval(this.interval)
  },
  computed: {
    formatted: function () {
      // pass config.lang and this.now as dummy args to make it reactive
      return dates.fromNow(this.value, this.$i18n.locale, this.now)
    }
  }
}
</script>



// WEBPACK FOOTER //
// DatetimeAgo.vue?71eb7501